(function () {
  'use strict';
  var start = Date.parse('2026-10-13T15:28:02Z');
  var end = Date.parse('2026-11-01T04:00:00Z');
  function isActive() { return Date.now() >= start && Date.now() < end; }
  function updateProduct(root, variantId) {
    root.dataset.currentVariant = variantId == null ? '' : String(variantId);
    var active = isActive();
    var found = false;
    root.querySelectorAll('[data-gg-spook-variant]').forEach(function (price) {
      var visible = active && price.dataset.ggSpookVariant === root.dataset.currentVariant;
      price.hidden = !visible;
      if (visible) found = true;
    });
    root.classList.toggle('gg-spook-has-price', found);
  }
  function refresh() {
    var active = isActive();
    document.querySelectorAll('[data-gg-spook-product]').forEach(function (root) {
      updateProduct(root, root.dataset.currentVariant);
    });
    document.querySelectorAll('[data-gg-spook-sale], [data-gg-spook-decoration]').forEach(function (el) { el.hidden = !active; });
    document.querySelectorAll('[data-gg-spook-original]').forEach(function (el) { el.hidden = active; });
  }
  if (window.jQuery) {
    window.jQuery(document).on('variantChange.ggSpook', function (event) {
      var root = event.target.querySelector('[data-gg-spook-product]');
      if (root) updateProduct(root, event.variant && event.variant.id);
    });
  }
  refresh();
  var expiryTimer = setInterval(function () { refresh(); if (Date.now() >= end) clearInterval(expiryTimer); }, 1000);
  document.addEventListener('visibilitychange', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
